import React, { useState } from 'react';
import { RuleForm } from '../molecules/RuleForm';
import { useCriteria } from '../../../hooks/Rules/useCriteria';
import Message from '../../../components/atoms/Message/Message';
import { createRule } from '../../../services/rulesService';
import { useNavigate } from 'react-router-dom';

export const CreateRuleForm = () => {
  const { criterias, loadCountriesAndCities, loadServiceCode, loadCities } = useCriteria();
  const [formIsLoading, setFormIsLoading] = useState(false);
  const [errMessage, setErrMessage] = useState('');
  const navigate = useNavigate();

  return (
    <div className="shadow-md bg-white rounded-3xl py-6 w-full mt-6">
      <RuleForm
        submitTitleButton={formIsLoading ? 'Cargando...' : 'Crear Regla'}
        isLoading={formIsLoading}
        onSubmit={(form) => {
          setFormIsLoading(true);
          createRule({
            name: form.name,
            description: '',
            criterias: form.criterias,
          })
            .then((response) => {
              if (!response.error) {
                navigate('/rules', {
                  state: {
                    message: {
                      message: 'Regla creada con éxito',
                      type: 'success',
                    },
                  },
                });
              } else {
                setErrMessage(response.message);
              }
            })
            .catch((e) => {
              setErrMessage(e.message);
            })
            .finally(() => {
              setFormIsLoading(false);
            });
        }}
        onCancel={() => {
          navigate('/rules');
        }}
        loadGeolocation={loadCountriesAndCities}
        loadCities={loadCities}
        loadServiceCode={loadServiceCode}
        criterias={criterias} />
      <div className="mb-6">
        {errMessage && <Message message={errMessage} type={'error'} />}
      </div>
    </div>
  );
};

export default CreateRuleForm;
